export default __webpack_public_path__ + "static/media/legales_desktop.7ced6421.png";